// normalize.css gives a button its own font and line-height, and Tailwind's preflight is off,
// so the native button styles are reset here.
export const recipientCopiesToggleStyles = {
  font: 'inherit',
  border: 'none',
  appearance: 'none',
  background: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '0 4px 0 0',
  borderRadius: '4px',
  cursor: 'pointer',
  color: ({ palette }) => palette.text.secondary,

  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.secondary,
  },
};
